import { toRefs } from 'vue'
import { storeToRefs } from 'pinia'
import type { RouteLocationNormalized } from 'vue-router'

import { useProjectCreationStore } from '~/portal/stores'

export const addressInfoMiddleware = async (
	_: RouteLocationNormalized,
	__: RouteLocationNormalized
) => {
	const projectStore = useProjectCreationStore()
	const { applicantInformation } = storeToRefs(projectStore)
	const { applicant } = toRefs(applicantInformation.value)

	const isEmptyApplicant = Object.values(applicant.value).some((value) => !!value)

	if (!isEmptyApplicant) {
		return 'project-creation'
	}
}
